import React from "react";
import footerLogo from "../assets/img/hoy-vemos-footer.svg";

const Footer = () => {
  return (
    <footer className="bg-[#172554] text-gray-400 text-center">
      <div className="container mx-auto py-6 px-6 flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:justify-between">
        
        {/* Logo del Footer */}
        <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-4">
          <img src={footerLogo} alt="Logo del Footer" className="h-16 w-auto" />
        </div>

        {/* Navegación del Footer */}
        <ul className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-6">
          <li>
            <a href="/privacy" className="hover:text-[#4f46e5]">
              Política de privacidad
            </a>
          </li>
          <li>
            <a href="/terminos" className="hover:text-[#4f46e5]">
              Términos y condiciones
            </a>
          </li>
          <li>
            <a 
              href="https://wa.me/50683012068" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-[#4f46e5]"
            >
              Contacto
            </a>
          </li>
        </ul>

      </div>

      {/* Derechos de Autor (Al Final) */}
      <div className="mt-4 pb-4 text-xs text-gray-500">
        © {new Date().getFullYear()} Hoy Vemos
      </div>
    </footer>
  );
};

export default Footer;
